import { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Select from "react-select";
import { Translate } from "../../../../../Enums/Tranlate";
import BranchesService from "../../../../../../services/Company/BranchesService";
import EmployeesService from "../../../../../../services/HRM/EmployeesService";
import FingerprintExclusionService from "../../../../../../services/HRM/FingerprintExclusionService";

const AddFingerprintExclusionModal = ({
	addModal,
	setAddModal,
	item = {},
	setShouldUpdate,
}) => {
	const [formData, setFormData] = useState({
		empolyees: "",
		branch: "",
	});
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth.lang);
	const branchesService = new BranchesService();
	const employeesService = new EmployeesService();
	const fingerprintExclusionService = new FingerprintExclusionService();
	const [empolyeesOptions, setEmpolyeesOptions] = useState([]);
	const [branchesOptions, setBranchesOptions] = useState([]);

	useEffect(() => {
		let promises = [branchesService.getList()];
		Promise.all(promises).then((res) => {
			if (res[0]?.status === 200) {
				let data = res[0]?.data?.data?.data?.map((info) => {
					return {
						label: info?.name,
						value: info?.id,
					};
				});
				setBranchesOptions(data);
			}

			if (Object.keys(item)?.length === 0) {
				setIsAdd(true);
			} else {
				setIsAdd(false);
				setFormData({
					id: item?.id,
					branch: {
						label: item?.branchName,
						value: item?.branchId,
					},
					empolyees: item?.exclusions?.map((emp) => {
						return {
							...emp,
							label: emp?.employeeName,
							value: emp?.employeeId,
						};
					}),
				});
			}
		});
	}, []);

	useEffect(() => {
		if (!!formData?.branch?.value) {
			let promises = [
				employeesService.getList({
					page: 1,
					limit: 1000,
					branchId: formData?.branch?.value,
				}),
			];
			Promise.all(promises).then((res) => {
				if (res[0]?.status === 200) {
					let data = res[0]?.data?.data?.data?.map((info) => {
						return {
							label: info?.name,
							value: info?.id,
						};
					});
					setEmpolyeesOptions(data);
				}
			});
		}
	}, [formData?.branch]);

	const submit = (e) => {
		e.preventDefault();
		let data = {
			branchId: formData?.branch?.value,
		};

		setLoading(true);
		if (isAdd) {
			data["employeeIds"] = formData?.empolyees?.map((res) => res?.value);
			fingerprintExclusionService
				.create(data)
				?.then((res) => {
					if (res && res?.status === 201) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			data["addEmployeeIds"] = formData?.empolyees?.map((res) => res?.value);
			data["removeEmployeeIds"] = item?.exclusions
				?.filter(
					(orig) =>
						!formData?.empolyees.some((upd) => upd.value === orig.employeeId),
				)
				?.map((res) => res?.employeeId);

			fingerprintExclusionService
				.update(data)
				?.then((res) => {
					if (res && res?.status === 200) {
						toast.success(res?.data?.message);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	return (
		<Modal
			className={
				lang === "en" ? "en fade addDepartment" : "ar fade addDepartment"
			}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={() => {
				setAddModal();
			}}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0"
									style={{
										fontWeight: "600",
										color: "#333",
										fontSize: "20px",
									}}>
									{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
									{Translate[lang]?.excluded_employees}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setAddModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>
						<Col md={12} className="mb-3">
							<label className="text-label">{Translate[lang]?.branch}</label>
							<Select
								value={formData?.branch}
								name="branch"
								placeholder={Translate[lang]?.select}
								options={branchesOptions}
								onChange={(e) => setFormData({ ...formData, branch: e })}
							/>
						</Col>
						<Col md={12} className="mb-3">
							<label className="text-label">{Translate[lang]?.employees}</label>
							<Select
								value={formData?.empolyees}
								name="empolyees"
								placeholder={Translate[lang]?.select}
								options={empolyeesOptions}
								isMulti
								onChange={(e) => setFormData({ ...formData, empolyees: e })}
							/>
						</Col>
						<Col md={12}>
							<Button
								variant="primary"
								type="submit"
								className="w-100"
								disabled={loading}>
								{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
							</Button>
						</Col>
					</Row>
				</Modal.Body>
			</AvForm>
		</Modal>
	);
};

export default AddFingerprintExclusionModal;
